export default __webpack_public_path__ + "locales/sk/ChangeUserStatusDialog.json?hash=0bc31304b0af7247c4e2ab5ca2b40051";